function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 5293"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 154446",
    style: {
      fill: "none"
    },
    d: "M0 0h18v18H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.471-731.84H220v-1.688h6.471V-740h1.688v6.471h6.471v1.688h-6.47v6.471h-1.688z",
    transform: "translate(-218.258 741.684)",
    style: {
      fill: "#121212"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomin);
export default __webpack_public_path__ + "static/media/zoomin.44c41aa66322d225885beda52ddc346a.svg";
export { ForwardRef as ReactComponent };